import { render, staticRenderFns } from "./ClientProfileCommerce.vue?vue&type=template&id=2b68bab4"
import script from "./ClientProfileCommerce.vue?vue&type=script&lang=js"
export * from "./ClientProfileCommerce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports